import { DjangoTimeStamped, TimeStamped } from './../django';
import { parseDate } from './../helpers/date';

export class CorporateGroup implements TimeStamped {
  id: string;
  isSso: boolean;
  name: string;
  siteDomain: string;
  estimatedEmployees: number;
  // DJANGO TIMESTAMPED
  created: Date;
  modified: Date;

  constructor(data: string | CorporateGroup | DjangoCorporateGroup = {}) {
    if (typeof data === 'string') {
      bindConstructorDataToInstance(this, { id: data });
    } else {
      bindConstructorDataToInstance(this, data);
    }
  }
}

export interface DjangoCorporateGroup extends DjangoTimeStamped {
  id?: string;
  is_sso?: boolean;
  name?: string;
  site_domain?: string;
  estimated_employees?: number;
  // DJANGO TIMESTAMPED
  modified?: string;
  created?: string;
}

export function parseCorporateGroup(data: string | DjangoCorporateGroup | CorporateGroup) {
  if (data) {
    return new CorporateGroup(data);
  } else {
    return undefined;
  }
}

///////////////
/// PRIVATE ///
///////////////
function bindConstructorDataToInstance(
  instance: CorporateGroup,
  data: CorporateGroup | DjangoCorporateGroup,
) {
  data = bindDjangoPropsToJs(data) as CorporateGroup;
  instance.id = data.id;
  instance.isSso = data.isSso;
  instance.name = data.name;
  instance.estimatedEmployees = data.estimatedEmployees;
  instance.siteDomain = data.siteDomain;
  instance.siteDomain = data.siteDomain;
  // DJANGO TIMESTAMPED
  instance.modified = parseDate(data.modified);
  instance.created = parseDate(data.created);
}

function bindDjangoPropsToJs(data: CorporateGroup | DjangoCorporateGroup) {
  const djangoData = data as DjangoCorporateGroup;
  const jsData = data as CorporateGroup;
  return {
    ...data,
    isSso: djangoData.is_sso || jsData.isSso,
    estimatedEmployees: djangoData.estimated_employees || jsData.estimatedEmployees,
    siteDomain: djangoData.site_domain || jsData.siteDomain,
  };
}
